import API from '../../utils/api';

/**
 * actions types
 * @type {String}
 */
export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';

/**
 * initial state
 * @type {Object}
 */
const initialState = {
  data: [],
  loading: false,
};

/**
 * reducer
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_PRODUCTS:
      return {
        ...state,
        loading: true,
      };

    case RECEIVE_PRODUCTS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };

    default:
      return state;
  }
}

/**
 * request products
 * @return {Object}
 */
export function requestProducts() {
  return { type: REQUEST_PRODUCTS };
}

/**
 * receive products
 * @param  {Object} data
 * @return {Object}
 */
export function receiveProducts(data) {
  return { type: RECEIVE_PRODUCTS, data };
}

export function fetchProducts() {
  return (dispatch) => {
    dispatch(requestProducts());

    API.getProducts().then(data => {
      const products = data.data.items || [];
      dispatch(receiveProducts(products));
    });
  };
}
